import { z } from 'zod';
/** RFC 4122 UUID (any version; Central generates UUIDv7). */
export const Uuid = z.uuid();
/** ISO-8601 timestamp with offset, e.g. 2026-09-25T10:15:03.412Z. */
export const IsoTimestamp = z.iso.datetime({ offset: true });
/**
 * External device reference chosen by a gateway: a namespaced identifier scheme and its value.
 * Central resolves it to its internal device id; gateways never need Central's UUIDs.
 */
export const DeviceRef = z.object({
    scheme: z
        .string()
        .min(1)
        .max(64)
        .regex(/^[a-z][a-z0-9_.-]*$/),
    value: z.string().min(1).max(128),
});
/**
 * Normalized metric key: dot-separated lowercase segments, e.g. `electrical.voltage_v`.
 * Vendor-specific values use the `vendor.` prefix (PROJECT_SPEC §17).
 */
export const MetricKey = z
    .string()
    .max(96)
    .regex(/^[a-z][a-z0-9_]*(\.[a-z0-9_]+)+$/);
/** Capability key, e.g. `light.set_dimmer`, `device.reset`, or a vendor capability. */
export const CapabilityKey = MetricKey;
/** Opaque, gateway-scoped connection reference. */
export const ConnRef = z.string().min(1).max(128);
export const JsonObject = z.record(z.string(), z.unknown());
//# sourceMappingURL=common.js.map